import {
  Flex, FlexColumn, ModelSelect, ModelTextarea,
} from '@equifinance/shared';
import styled from 'styled-components';
import { formatDateTime } from '@equifinance/shared/utils';
import { PolicyShieldsRuleDecisionType, PolicyShieldsRuleOutcome } from '../../../../../../contexts';
import { SelectWrapper } from '../../../../components/UnderwriterDecision';

const Container = styled(FlexColumn)`${({ theme }) => `
  border-radius: 0 0 ${theme.padding[2]} ${theme.padding[2]};
  background-color: ${theme.colours.neutral[10]};
  box-shadow: 0 1px 3px 0 rgba(16, 24, 40, 0.10), 0 1px 2px 0 rgba(16, 24, 40, 0.06);
`}`;

const Header = styled(Flex)`${({ theme }) => `
  align-items: center;
  justify-content: space-between;
  gap: ${theme.padding[4]};
  padding: ${theme.padding[3]};
  background: ${theme.colours.tertiary[6]};
`}`;

const HeaderLeft = styled.div``;

const Title = styled.h1`${({ theme }) => `
  color: ${theme.colours.neutral[2]};
  font-family: Montserrat;
  font-size: ${theme.fontSize[2]};
  font-weight: ${theme.fontWeight.bold};
`}`;

const SubText = styled.p`${({ theme }) => `
  color: ${theme.colours.neutral[2]};
  font-size: ${theme.fontSize[1]};
`}`;

const Content = styled.div`${({ theme }) => `
  padding: ${theme.padding[4]};
`}`;

const MetaRow = styled(Flex)`${({ theme }) => `
  align-items: center;
  flex-wrap: wrap;
  gap: ${theme.padding[3]};
  font-size: ${theme.fontSize[2]};
  color: ${theme.colours.neutral[2]};
  margin-bottom: ${theme.padding[2]};
`}`;

const MetaLabel = styled.span`${({ theme }) => `
  font-weight: ${theme.fontWeight.bold};
`}`;

const MetaValue = styled.span`${({ theme }) => `
  color: ${theme.colours.neutral[2]};
`}`;

const Divider = styled.span`${({ theme }) => `
  width: 1px;
  height: ${theme.fontSize[2]};;
  background: #d9d9d9;
  display: inline-block;
  margin: 0 2px;
`}`;

const RuleDecision = styled(SelectWrapper)`${({ theme }) => `
  min-width: ${theme.dropdownWidth};
`}`;

export function RuleOutcomeItem({ ruleOutcome, index }: { index?: number, ruleOutcome: PolicyShieldsRuleOutcome }) {
  const {
    title, description, decisionTimestamp, decisionByName, decision,
  } = ruleOutcome;

  const path = `policyShields.ruleOutcomes[${index}]`;

  return (
    <Container>
      <Header>
        <HeaderLeft>
          <Title>{title}</Title>
          <SubText>{description}</SubText>
        </HeaderLeft>

        <RuleDecision>
          <ModelSelect
            placeholder="Please select"
            field={`${path}.decision`}
            options={PolicyShieldsRuleDecisionType}
          />
        </RuleDecision>
      </Header>

      <Content>
        {decision && (
          <MetaRow>
            <MetaLabel>Decision by:</MetaLabel>
            <MetaValue>{decisionByName}</MetaValue>
            <Divider />
            <MetaLabel>Date and time:</MetaLabel>
            <MetaValue>{formatDateTime(decisionTimestamp, 'DD/MM/YYYY, HH:mm:ss')}</MetaValue>
          </MetaRow>
        )}

        <ModelTextarea
          field={`${path}.justification`}
          label="Justification"
          required
          rows={3}
        />
      </Content>
    </Container>
  );
}
